// Shared patient-search term routing.
//
// Both the Patients board and the FTC Tasks page offer a single
// "Search Patient" box that has to stand in for three separate backend filters.
// The shape of what was typed picks the filter: all digits -> phone, something
// that parses as an email -> email, anything else -> name. Keeping this in one
// place means the two pages can't drift apart in what a given query matches.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Map a free-text query onto the backend's name / email / phone params.
 *
 * Always returns all three keys so callers can spread the result over existing
 * filter state and clear whichever fields no longer apply.
 *
 * @param {string} query raw search box contents
 * @returns {{name: string, email: string, phone: string}}
 */
export function patientSearchParams(query) {
  const params = { name: "", email: "", phone: "" };
  const q = (query || "").trim();
  if (!q) return params;

  if (!isNaN(q)) {
    params.phone = q;
  } else if (EMAIL_RE.test(q)) {
    params.email = q;
  } else {
    params.name = q;
  }
  return params;
}

export default patientSearchParams;
